import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 8.25,
			y: 1.5,
			width: 1.5,
			height: 15,
			rx: .75,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.25,
			y: 1.5,
			width: 1.5,
			height: 15,
			rx: .75,
			fill: "black",
			transform: "rotate(60 9 9)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.25,
			y: 1.5,
			width: 1.5,
			height: 15,
			rx: .75,
			fill: "black",
			transform: "rotate(120 9 9)"
		})
	]
});
export default SvgAction;
